<template>
  <div class="temporaryInteractionRootBox" v-if="showToolsBox">
    <levitation-button v-if="!isStudent" @btShowChange="btShowChange">
      <template #lvBt="{status}">
        <i class="el-icon-data-analysis" ref="lvBt" :style="{color:status?'#21a7fd':null}" style="font-size: 2em"></i>
      </template>
      <template>
        <div>
          <div v-for="(item,index) in buttons" :key="index" class="itemBox" @click="item.click($event,item,index)">
            <i :class="item.img" style="font-size: 2.2em"></i>
          </div>
        </div>
      </template>
    </levitation-button>
    <el-dialog :title="getDiaLogTitle()" :visible.sync="showDialog" width="800px"
               :destroy-on-close="true" :close-on-click-modal="false" append-to-body :before-close="beforeClose">
      <div class="dialogRootBox">
        <div class="diaLogLeftBox">
          <!--      选择题-->
          <div class="selectBox"
               v-if="questionType.interactionType === types.select && questionType.selectList && questionType.selectList.length">
            <div class="selectItemBox" v-for="item in questionType.selectList" :key="item.id">
              <div class="selectItemText" @click="selectAnswer(item)" :style="getSelectItemStyle(item)">
                {{ item.interactionItem }}
              </div>
              <div class="percentage"
                   :style="{cursor: questionType.inProgress === inProgressTypes.end ? 'pointer' : null}"
                   v-show="questionType.inProgress >=inProgressTypes.end" @click="publishAnswers(item)">
                <el-progress type="circle"
                             :percentage="parseFloat(getPercentage(item))"
                             :format="()=>(`${item.completedTotal||'0'}/ ${getPercentageStr(item)}%`)"
                             :stroke-width="6"
                             :width="80"
                             :color="getProgressColor(item)"
                >
                </el-progress>
              </div>
            </div>
            <div class="selectItemBox"
                 v-if="(questionType.currentCode < maxCode) && questionType.inProgress === inProgressTypes.start && !isStudent"
                 @click="add(questionType.selectList)">
              <div class="selectItemText addSub">+</div>
            </div>
            <div class="selectItemBox" @click="sub(questionType.selectList)"
                 v-if="questionType.inProgress === inProgressTypes.start && !isStudent">
              <div class="selectItemText addSub">-</div>
            </div>
          </div>

          <!--      判断题-->
          <div class="judgeBox" v-if="questionType.interactionType === types.judge">
            <div class="judgeItemBox" v-for="(item,index) in questionType.judges" :key="item.id"
                 :style="getSelectItemStyle(item,index)">
              <div @click="selectAnswer(item)">
                <i :class="item.clazz"></i>
              </div>
              <div class="percentage"
                   :style="{cursor: questionType.inProgress === inProgressTypes.end ? 'pointer' : null}"
                   v-show="questionType.inProgress >= inProgressTypes.end" @click="publishAnswers(item)">
                <el-progress type="circle"
                             :percentage="parseFloat(getPercentage(item))"
                             :format="()=>(`${item.completedTotal||'0'}/${getPercentageStr(item)}%`)"
                             :stroke-width="6"
                             :width="80"
                             :color="getProgressColor(item)"
                >
                </el-progress>
              </div>
            </div>
          </div>

          <template name="footer" v-if="questionType.inProgress!==inProgressTypes.end">
            <el-button-group style="position: absolute;right: 20px;bottom: 20px">
              <!--              <el-button @click="closeDiaLog">取消</el-button>-->
              <el-button type="primary" @click="getButtonData().click()" :questionType.loading="questionType.loading">
                {{ getButtonData().text }}
              </el-button>
            </el-button-group>
          </template>
          <span v-if="questionType.inProgress === inProgressTypes.end"
                style="position: absolute;left: 30px;bottom: 30px;"> tips：<span
            style="color: #21a7fd">点击正确答案下的 圆环 公布答案</span> </span>
          <span v-if="isStudent && !questionType.currentSelectName"
                style="position: absolute;left: 30px;bottom: 30px;"> tips：<span
            style="color: #21a7fd">请选择答案</span> </span>
          <span v-if="isStudent && questionType.currentSelectName"
                style="position: absolute;left: 30px;bottom: 30px;"> tips：<span
            style="color: #21a7fd">您选择了 {{ questionType.currentSelectName }}</span> </span>
          <span v-if="questionType.inProgress === inProgressTypes.publish"
                style="position: absolute;left: 30px;bottom: 30px;"> tips：<span
            style="color: #21a7fd">正确答案是 {{ questionType.currentSelectName }}</span> </span>

        </div>
        <!--===========================下面显示文本数据=============================-->
        <div class="dialogRightBox"
             v-show="questionType.inProgress!==inProgressTypes.start && questionType.inProgress!==inProgressTypes.publish">
          <h3>作答详情</h3>
          <div>
            <p class="num">{{ questionType.completedTotal || '0' }}<span>/{{ questionType.stuTotal || '0' }}</span></p>
            <p class="tip">已作答</p>
          </div>
        </div>
        <dl class="dialogRightHonorBox" v-show="questionType.inProgress===inProgressTypes.publish">
          <dt>正确手速榜</dt>
          <div v-if="!honorList || !honorList.length" style="margin-top: 40px">暂无学生答对</div>
          <dd v-else v-for="item in honorList" :key="item">{{ item }}</dd>
        </dl>
      </div>
    </el-dialog>

    <!--===========================下面是互动=============================-->
<!--    <im :visible.sync="imVisible" :start-el="startEl"></im>-->
  </div>
</template>

<script>
import LevitationButton from "@/views/component/LevitationButton";
import {
  addUntitledStemInteraction,
  endInteraction,
  queryClassHour, queryFirstThree,
  queryStatisticsByInteraction,
  saveStudentAnswer, showUntitledStemInteraction
} from "@/api/PostUrl";
// import Im from "@/views/szrt_revision/teachingDetail/list/classroom/im";

export default {
  components: {LevitationButton},
  title: '临时互动',
  name: "temporaryInteraction",
  props: {
    commonData: {
      type: Object,
      default: () => ({
        courseId: null,
        classId: null,
        catalogId: null,
        catalogType: null
      })
    },
    userType: {
      type: [String, Number],
      default: 1
    },
    showToolsBox: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    commonData: {
      handler(data) {
        this.initData = {...this.initData, ...data}
      },
      immediate: true
    },
    userType: {
      handler(newVal) {
        this.isStudent = (String(newVal) === '2')
      },
      immediate: true
    }
  },
  computed: {
    getDiaLogTitle() {
      return function () {
        let title = ''
        if (this.questionType.interactionType === this.types.select) {
          title = '临时互动-选择题'
        } else if (this.questionType.interactionType === this.types.judge) {
          title = '临时互动-判断题'
        }
        return title
      }
    },
    getButtonData() {
      return function () {
        let data = {
          text: '发送',
          click: this.saveStudentAnswer
        }
        if (this.isStudent) {
          return data
        }
        switch (this.questionType.inProgress) {
          case this.inProgressTypes.start:
            data.text = '发起'
            data.click = this.launch
            break
          case this.inProgressTypes.exec:
            data.text = '结束'
            data.click = this.closure
            break
          case this.inProgressTypes.publish:
            data.click = this.closeDiaLog.bind(this, this.inProgressTypes.publish)
            data.text = '关闭'
            break
        }
        return data
      }
    },
    getSelectItemStyle() {
      return function (item, index) {
        if (this.isStudent) {
          if (this.questionType.interactionType === this.types.select) {
            return {
              cursor: 'pointer',
              border: item.id === this.questionType.currentSelectId ? '6px solid #21a7fd' : '6px solid #ecf0f1',
              borderRadius: '50%',
              margin: '15px',
              padding: '10px',
              color: item.id === this.questionType.currentSelectId ? '#21a7fd' : null,
              'box-sizing': 'content-box'
            }
          } else {
            let border = (item.id === this.questionType.currentSelectId && index === 1) ? '#f56c6c' : null
            border = (item.id === this.questionType.currentSelectId && index === 0) ? '#5cb85c' : border
            border = border ? `${border} 6px solid` : border
            return {
              cursor: 'pointer',
              border: border,
              borderRadius: '50%',
              margin: '15px',
              padding: '10px',
              'box-sizing': 'content-box'
            }
          }
        }
        return null
      }
    },
    getCompletedTotal() {
      return function () {
        let list = []
        if (this.questionType.interactionType === this.types.select) {
          list = this.questionType.selectList
        } else if (this.questionType.interactionType === this.types.judge) {
          list = this.questionType.judges
        }
        return list.reduce((sum, it) => sum + it.completedTotal, 0)
      }
    },
    getPercentage() {
      return function (item) {
        return (item.id === this.questionType.currentSelectId && this.questionType.inProgress === this.inProgressTypes.publish) ? 100.00 : this.getPercentageStr(item)
      }
    },
    getPercentageStr() {
      return function (item) {
        return ((Number(item.completedTotal || 0) / (this.questionType.stuTotal || 1)) * 100).toFixed(2)
      }
    },
    getProgressColor() {
      return function (item) {
        return this.questionType.inProgress === this.inProgressTypes.publish ? (item.id !== this.questionType.currentSelectId) ? item.completedTotal ? 'rgb(255, 73, 73)' : null : 'rgb(19, 206, 102)' : null
      }
    }
  },
  data() {
    return {
      startEl: null,
      imVisible: false,
      webService: null,
      isStudent: false,
      showDialog: false,
      maxCode: 70,//最大的选择项
      minCode: 66,//最小的选择项
      questionTypeCopy: {},//为了重置数据使用
      questionType: {
        currentCode: 68,
        loading: false,
        inProgress: 0,
        currentSelectId: null,
        currentSelectName: null,
        completedTotal: 0,//已作答
        stuTotal: 0,//学生数量
        interactionType: null,//互动类型 0.选择题 1.判断题
        interactionId: null,//当前互动题id
        selectList: [
          {
            interactionItem: 'A',
            completedTotal: 0
          },
          {
            interactionItem: 'B',
            completedTotal: 0
          },
          {
            interactionItem: 'C',
            completedTotal: 0
          },
          {
            interactionItem: 'D',
            completedTotal: 0
          },
        ],
        judges: [
          {
            interactionItem: '对',
            clazz: 'el-icon-success',
            completedTotal: 0
          },
          {
            interactionItem: '错',
            clazz: 'el-icon-error',
            completedTotal: 0
          }
        ]
      },
      honorList: [],
      inProgressTypes: {//老师使用
        start: 0,//初始状态
        exec: 1,//执行中状态
        end: 2,//结束状态
        publish: 3//公布答案状态
      },
      types: {
        select: 0,//选择题类型
        judge: 1,//判断题类型
      },
      buttons: [
        {
          title: '选择题',
          img: 'iconfont icon-ABC',
          itemType: 0,
          click: (event, item, index) => this.openDialog(item, index)
        }, {
          title: '判断题',
          itemType: 1,
          img: 'iconfont icon-panduan',
          click: (event, item, index) => this.openDialog(item, index)
        },
        // {
        //   title: '互动',
        //   itemType: 2,
        //   img: 'iconfont icon-liaotian',
        //   click: (event, item, index) => this.openIm(event, item, index)
        // },
        // {
        //   title: '学生提问',
        //   img: 'el-icon-question',
        // }
      ],
      initData: {
        courseId: null,
        classId: null,
        catalogId: null,
        classHour: null,
        catalogType: null
      }
    }
  },
  created() {
    this.questionTypeCopy = JSON.stringify(this.questionType)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDataFun()
      this.btShowChange()
    })
  },
  destroyed() {
    this.endService()
  },
  methods: {
    btShowChange(status) {
     this.$nextTick(()=>{
       if (!status) {
         this.startEl = this.$refs.lvBt
       }
     })
    },
    async initDataFun() {
      if (this.showToolsBox) {//必须开启才能使用
        await this.queryClassHour();
        !this.isStudent && await this.queryStatisticsByInteraction();
        await this.startListenerService();
      }
    },
    async openDialog(item) {
      await this.initDataFun()
      if (this._$isInteger(item.itemType)) {
        if (this.questionType.inProgress !== this.inProgressTypes.exec) {
          this.resetData()
          this.questionType.interactionType = item.itemType
        } else {
          if (item.itemType !== this.questionType.interactionType) {
            this.$messageWarning(`当前存在进行中的试题，请结束后使用【${item.itemType === this.types.select ? '选择题' : '判断题'}】`)
          }
        }
        this.showDialog = true
      }
    },
    resetData() {
      this.questionType = JSON.parse(this.questionTypeCopy)
    },
    setItemEntityList(itemEntityList = []) {
      if (this.questionType.interactionType === this.types.select) {//选择题
        this.questionType.selectList = itemEntityList
      } else if (this.questionType.interactionType === this.types.judge) {//判断题
        itemEntityList.forEach((item, index) => {
          this.questionType.judges[index].id = item.id
          this.questionType.judges[index].completedTotal = item.completedTotal
        })
      }
    },
    setMegBoxZIndex() {
      const id = setInterval(() => {
        const div = document.querySelector('.el-message-box__wrapper')
        if (div && div.style) {
          div.style.zIndex = '3600'
          clearInterval(id)
        }
      }, 50)
    },
    beforeClose(done) {
      if (this.questionType.inProgress === this.inProgressTypes.end) {
        this.$showConfirm(`老师，您还未公布答案是否关闭?`, () => done && done())
        this.setMegBoxZIndex()
      } else {
        done && done()
      }
    },
    // ========================================下面是老师使用时的处理逻辑============================================
    /**
     *选择题 添加选项
     * @param list
     */
    add(list = []) {
      this.questionType.currentCode = list[list.length - 1].interactionItem.charCodeAt(0) + 1
      if (this.questionType.currentCode <= this.maxCode) {
        list.push({
          interactionItem: String.fromCharCode(this.questionType.currentCode),
          completedTotal: 0
        })
      }
    },
    /**
     * 选择题 减去选项
     * @param list
     */
    sub(list = []) {
      if (this.questionType.currentCode > this.minCode) {
        list.pop()
        --this.questionType.currentCode
      }
    },
    /**
     * 发起
     */
    async launch() {
      const param = {
        ...this.initData,
        interactionType: this.questionType.interactionType,
        itemList: this.getItemList()
      }
      console.log('发起...')
      await this.$apiPost.httpPostForMap(addUntitledStemInteraction, param)
      this.questionType.inProgress = this.inProgressTypes.exec //进行中
      console.log('进行中...', this.questionType.inProgress)
      await this.queryStatisticsByInteraction()
      await this.startListenerService()
    },
    /**
     * 获取选择的题数据
     */
    getItemList() {
      if (this.questionType.interactionType === this.types.select) {//选择题
        return this.questionType.selectList.map(item => item.interactionItem)
      } else if (this.questionType.interactionType === this.types.judge) {//判断题
        return this.questionType.judges.map(item => item.interactionItem)
      }
      return null
    },
    /**
     * 结束
     */
    async closure() {
      const param = {...this.initData}
      console.log('结束...')
      await this.$apiPost.httpPostForMap(endInteraction, param)
      this.questionType.inProgress = this.inProgressTypes.end //已结束
      console.log('已结束...', this.questionType.inProgress)
    },
    /**
     * 查询当前课时
     */
    async queryClassHour() {
      let param = {
        classId: this.initData.classId,
        courseId: this.initData.courseId,
      }
      const {classHour} = await this.$apiPost.httpPostForMap(queryClassHour, param)
      this.initData.classHour = `${classHour}`
    },
    /**
     * 查询老师 问题进行中的数据
     */
    async queryStatisticsByInteraction() {
      const param = {...this.initData}
      const data = await this.$apiPost.httpPostForMap(queryStatisticsByInteraction, param)
      if (data instanceof Object) {
        this.resetData()
        const {itemEntityList, interactionType, stuTotal, id, completedTotal} = data
        this.questionType.interactionType = interactionType
        this.questionType.completedTotal = completedTotal
        this.questionType.stuTotal = stuTotal
        this.questionType.interactionId = id
        this.questionType.inProgress = this.inProgressTypes.exec
        this.showDialog = true
        this.setItemEntityList(itemEntityList)
      }
    },
    /**
     * 老师公布答案
     */
    publishAnswers(item) {
      if (this.questionType.inProgress === this.inProgressTypes.end) {
        this.$showConfirm(`老师，您是否选择【${item.interactionItem}】作为答案?`, async () => {
          if (this.questionType.inProgress === this.inProgressTypes.end) {
            this.questionType.currentSelectId = item.id
            this.questionType.currentSelectName = item.interactionItem
            await this.queryFirstThree(item)
          }
        })
        this.setMegBoxZIndex()
      }
    },
    /**
     * 老师公布答案接口
     */
    async queryFirstThree(item) {
      const param = {
        classId: this.initData.classId,
        interactionId: this.questionType.interactionId,
        answerId: item.id
      }
      const list = await this.$apiPost.httpPostForMap(queryFirstThree, param)
      this.honorList = list || []
      this.questionType.inProgress = this.inProgressTypes.publish
    },
    /**
     * 关闭dialog
     */
    closeDiaLog(inProgress) {
      this.showDialog = false
      if (inProgress === this.inProgressTypes.publish) {
        setTimeout(() => this.questionType.inProgress = this.inProgressTypes.start)
      }
    },

    // ========================================下面是学生使用时的处理逻辑============================================
    /**
     * 学生查询当前状态
     */
    async showUntitledStemInteraction() {
      const param = {...this.initData}
      const data = await this.$apiPost.httpPostForMap(showUntitledStemInteraction, param)
      this.resetData()
      if (data instanceof Object) {
        const {itemEntityList, interactionType, id} = data
        this.questionType.interactionType = interactionType
        this.questionType.interactionId = id
        this.showDialog = true
        this.setItemEntityList(itemEntityList)
      } else {
        this.showDialog = false
      }
    },

    /**
     * 学生答题
     */
    async saveStudentAnswer() {
      const save = () => {
        const param = {
          interactionId: this.questionType.interactionId,
          answer: this.questionType.currentSelectId
        }
        this.$apiPost.httpPostForMap(saveStudentAnswer, param)
        this.showDialog = false
      }

      if (this.questionType.currentSelectId == null) {
        this.$showConfirm(`您还没有选择答案，努力就有成功的机会，确定就这样放弃？`, save)
      } else {
        this.$showConfirm(`同学，您是否选择【${this.questionType.currentSelectName}】作为答案?`, save)
      }
      this.setMegBoxZIndex()
    },

    selectAnswer(item) {
      if (this.isStudent) {
        this.questionType.currentSelectId = item.id
        this.questionType.currentSelectName = item.interactionItem
      }
    },
    // ==========================================下面是一个监听器==========================================================
    /**
     * 启动一个监听服务
     */
    async startListenerService() {
      this.endService()
      this.webService = setInterval(this.execWebService, 2000)
    },
    async execWebService() {
      if (this.questionType.inProgress === this.inProgressTypes.end) {
        this.endService()
      } else if (this.isStudent && !this.showDialog) {//学生
        await this.showUntitledStemInteraction()
      } else if (!this.isStudent && this.questionType.inProgress === this.inProgressTypes.exec && this.showDialog) {//老师
        await this.queryStatisticsByInteraction()
      }
    },

    /**
     * 结束循环
     */
    endService() {
      clearInterval(this.webService)
    },
    openIm(event) {
      this.startEl = event.target
      this.$nextTick(()=> this.imVisible = true)
    }
  }
}
</script>

<style scoped lang="scss">
@import url('../../../../../../src/assets/fonts/duoxuanpanduan/iconfont.css');

$height: 180px;
@mixin common_flex {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.temporaryInteractionRootBox {
  position: fixed;
  z-index: 99999;
}

/deep/ .el-dialog {
  pointer-events: auto !important;
}

/deep/ .el-dialog__wrapper {
  z-index: 3500 !important;
}

.dialogRootBox {
  height: 250px;
  display: flex;
  justify-content: space-evenly;
  align-items: start;
  padding: 20px;
}

.dialogRightBox {
  @include common_flex;
  width: 20%;
  background-color: rgba(236, 240, 241, 0.58);
  border: 5px dashed #ecf0f1;
  height: $height;
  margin-left: 20px;
  user-select: none;

  & > div {
    @include common_flex;

    .num {
      font-size: 34px;

      & > span {
        font-size: 20px;
      }
    }

    .tip {
      font-size: 12px;
      margin-top: 5px;
    }
  }
}


.itemBox {
  @include common_flex;
  width: 50px;
  height: 50px;
  background-color: rgba(235, 239, 243, 0.2);
  box-shadow: 0 0 4px rgba(79, 78, 78, 0.2);
  border-radius: 10px;
  cursor: pointer;
  margin: 10px;
  backdrop-filter: blur(5px);
  transition: all .5s linear;
}

.itemBox:hover {
  transform: translateY(-5px) scale(1.1);
}

.selectBox {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}

.selectItemBox {
  height: $height;
  @include common_flex;
  //justify-content: center;

  & > div.selectItemText {
    box-sizing: border-box;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    width: 60px;
    //border: 5px solid #ecf0f1;
    font-size: 4em;
  }
}

.percentage {
  pointer-events: auto;
  user-select: none;
  margin: 0 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.percentage:hover {
  background: radial-gradient(at center, #f8f8f4, #fcf8c9, #f5ed94, #ffea00);
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

.addSub {
  user-select: none;
  border: 2px dashed #ecf0f1;
  border-radius: 50%;
  padding-bottom: 8px;
  margin: 4px;
  cursor: pointer;
}

.judgeBox {
  user-select: none;
  width: 300px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: $height;

  & > div:nth-of-type(1) i {
    color: #5cb85c;
    font-size: 6em;
  }

  & > div:nth-of-type(2) i {
    color: #f56c6c;
    font-size: 6em;
  }

  .judgeItemBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    user-select: none;
  }
}

.dialogRightHonorBox {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: rgba(236, 240, 241, 0.58);
  border: 5px dashed #ecf0f1;
  height: $height;
  user-select: none;
  width: 20%;

  dt {
    margin-top: 10px;
    height: 40px;
    font-weight: 600;
  }

  & > dd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 30px);
    font-size: 14px;
    position: relative;
    box-sizing: border-box;
    height: 4em;
    overflow-y: auto;
    padding-left: 30px;

  }

  ::-webkit-scrollbar {
    display: none;
  }

  & > dd::before {
    margin-right: 5px;
    height: 26px;
    min-width: 26px;
    display: block;
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  & > dd:nth-of-type(1)::before {
    background: url(../../../../../../src/assets/image/icon/icon_honor_1.png) no-repeat;
    background-size: 100%;
  }

  & > dd:nth-of-type(2)::before {
    background: url(../../../../../../src/assets/image/icon/icon_honor_2.png) no-repeat;
    background-size: 100%;
  }

  & > dd:nth-of-type(3)::before {
    background: url(../../../../../../src/assets/image/icon/icon_honor_3.png) no-repeat;
    background-size: 100%;
  }
}

/deep/ .el-message-box .msgBoxCustomClass {
  z-index: 9999;
}

//@for $i from 1 to 4 {
//}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/temporaryInteraction.vue